export default {
  title: 'Login',
  type: 'object',
  properties: {
    password: {
      type: 'string',
      title: 'Hasło',
      fieldRequired: 'true',
      minLength: 8
    },
    email: {
      type: 'string',
      format: 'email',
      title: 'Email',
      fieldRequired: 'true',
      validationMessages: {
        format: 'Niepoprawny format adresu e-mail'
      }
    }
  }
};
